import { injectable, interfaces } from 'inversify';
import { IObservableArray, makeObservable, observable } from 'mobx';
import { IPagingInfoWithOrder, PaginationInfoDefault } from '../../__legacy__/models/paginationInfo.model';

const DEFAULT_VALUES = {
  workspaces: [],
  workspacesPaging: {
    ...PaginationInfoDefault,
    orderBy: 'name',
    orderType: 'asc',
  },
  search: '',
};

export interface IWorkspace {
  id: string;
  name: string;
  ownerCompany: string;
  ownerEmail: string;
  cloudCostsLimit: number;
  totalCostActual: number;
  totalCostCalculated: number;
}

export interface IAdminStore {
  workspaces: IObservableArray<IWorkspace>;
  workspacesPaging: IPagingInfoWithOrder;
}

export namespace IAdminStore {
  export const $: interfaces.ServiceIdentifier<IAdminStore> = Symbol('ADMIN_STORE');
}

@injectable()
export class AdminStore implements IAdminStore {
  workspaces: IObservableArray<IWorkspace> = observable.array([]);
  workspacesPaging: IPagingInfoWithOrder = DEFAULT_VALUES.workspacesPaging;

  constructor() {
    makeObservable(this, {
      workspaces: observable,
      workspacesPaging: observable,
    });
  }
}
